import React from "react";
import { FormattedMessage } from "react-intl";
import { ErrorIcon } from "@ticketmaster/aurora";
import { ErrorButton, ErrorContainer, IconCircle, TicketsError } from "./styles";
import Icon from '../../../components/icon';
import ticketsError from '../../../components/icon/svg/tickets-error.svg';
import get from 'lodash/get'

export const ErrorDisplayDetails  = {
  button: {
    default: 'default',
    pending: 'pending',
    notAvailable: 'notAvailable',
    expired: 'default',
  },
  title: {
    default: 'default',
    pending: 'pending',
    notAvailable: 'notAvailable',
    expired: 'notAvailable',
  },
  error: {
    default: 'default',
    pending: 'pending',
    notAvailable: 'notAvailable',
    expired: 'expired',
  },
}

export const DEFAULT_ERROR = 'default';
export const PENDING_ERROR = 'pending';
export const NOT_AVAILABLE = 'notAvailable';
export const EXPIRED = 'expired';

function renderStateIcon(state, css) {
  switch (state) {
    case DEFAULT_ERROR:
      return (
        <IconCircle>
          <ErrorIcon size="large" color="#bfbfbf" />
        </IconCircle>
      );

    case PENDING_ERROR:
    case NOT_AVAILABLE:
    case EXPIRED:
      return (
          <Icon
          css={css}
          glyph={ticketsError}
          customStyles
          />
      );

    default:
      return (
        <IconCircle>
          <ErrorIcon size="large" color="#bfbfbf" />
        </IconCircle>
      );
  }
}


const SocialShareError = ({ errorDetails, css, eventId }) => {
  const buttonHandler = () => {
    switch (errorDetails) {
      case PENDING_ERROR:
        window.location.reload();
        break;
      case NOT_AVAILABLE:
        window.location.href = `${get(window,"siteContext.desktopSite",false)}/event/${eventId}`;
        break;
      case EXPIRED:
        window.location.href = siteContext.desktopIccpSite;
        break;
      default:
        window.location.reload();
        break;
    }
  }
  return (
    <ErrorContainer>
        {renderStateIcon(errorDetails, css)}     
      <h1>
        <FormattedMessage id={`social-share.error.title.${ErrorDisplayDetails.title[errorDetails]}`} />
      </h1>
      <h2>
        <FormattedMessage id={`social-share.error.${ErrorDisplayDetails.error[errorDetails]}`} />
      </h2>
      <ErrorButton onClick={buttonHandler}>
        <FormattedMessage id={`social-share.error.button.${ErrorDisplayDetails.button[errorDetails]}`} />
      </ErrorButton>
    </ErrorContainer>
  );
};

export default SocialShareError;
